import styled, {css, DefaultTheme} from 'styled-components'
import {TreatmentRequestSmall} from '@/features/treatment-requests/types.ts'

const getStatusColor = (status: TreatmentRequestSmall['status'], palette: DefaultTheme['palette']) => {
    const statusToColors = {
        in_review: palette.purple['400'],
        waiting_list: palette.orange['500'],
        in_progress: palette.primary['500'],
        accepted: palette.green['500'],
        rejected: palette.red['500'],
        deprecated: palette.neutral['500']
    } as const satisfies Record<TreatmentRequestSmall['status'], string>

    return statusToColors[status]
}

export const StyledStatusBullet = styled.span<{$status: TreatmentRequestSmall['status']}>(
    ({theme: {palette, opacities}, $status}) => css`
        width: 8px;
        height: 8px;
        border-radius: 2px;
        border: 1px solid ${palette.neutral.black}${opacities['10']};
        background-color: ${getStatusColor($status, palette)};
    `
)
